import React, { useState, useEffect } from 'react';
import './Header.scss';

const NAV_LINKS = [
  { href: '#prices',       label: 'Prices' },
  { href: '#finder',       label: 'Finder' },
  { href: '#fuel-guide',   label: 'Guide' },
  { href: '#reg',          label: 'My Car' },
  { href: '#alerts',       label: 'Alerts' },
];

export default function Header({ onSubscribeClick }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`header${scrolled ? ' header--scrolled' : ''}`}>
      <div className="header__inner">
        <div className="header__logo">TTT</div>

        <nav className="header__nav">
          {NAV_LINKS.map(({ href, label }) => (
            <a key={href} href={href} className="header__nav-link">
              {label}
            </a>
          ))}
        </nav>

        <div className="header__right">
          <div className="header__live">
            <span className="header__live-dot" />
            LIVE
          </div>
          <button className="header__subscribe-btn" onClick={onSubscribeClick}>
            Subscribe
          </button>
          <button
            className={`header__burger${menuOpen ? ' open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <span /><span /><span />
          </button>
        </div>
      </div>

      {/* Mobile nav */}
      {menuOpen && (
        <nav className="header__mobile-nav">
          {NAV_LINKS.map(({ href, label }) => (
            <a key={href} href={href} className="header__mobile-link" onClick={() => setMenuOpen(false)}>
              {label}
            </a>
          ))}
          <button className="header__mobile-sub" onClick={() => { setMenuOpen(false); onSubscribeClick(); }}>
            Subscribe for Alerts →
          </button>
        </nav>
      )}
    </header>
  );
}
